import * as React from "react";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import IconTimesCircle from "components/Icons/IconTimesCircle";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { useTranslation } from 'react-i18next';

const ButtonReproval: React.FC<MuiRegularButtonProps & { text?: string; }> = (props) => {
    const { text, justIcon, ...rest } = props;
    const { t } = useTranslation();
    return (
        <MuiRegularButton
            {...rest}
            justIcon={justIcon}
        >
            <MuiColor variant="error" >
                <div style={{ float: "left" }}><IconTimesCircle fixedWidth /></div>
                {!justIcon && (text || <span>{t("Common.Buttons.ReprovalText")}</span>)}
            </MuiColor>
        </MuiRegularButton>
    );
};

ButtonReproval.defaultProps = {
    color: "transparent",
    justIcon: true

};
export default ButtonReproval;
